<template>
  <div>
    <div :class="['gameplay_bg', gameType === 'MEMORY' ? 'memory' : gameType === 'ATTENTION' ? 'attention':'logic']">
      <div class="gameplay_bar"></div>
      <div class="container">
        <timer/>
        <game-header/>
        <component  :is="brainiacMiniGameMap[miniGameType].miniGameComponent" :key="miniGames[currentMiniGameRound].id"/>
      </div>
      <game-footer/>
    </div>
    <component :is="componentModal" @startNewGame="startNewGameMethod" @close="showModal"/>
    <component :is="modalForHomePage"/>
  </div>
</template>

<script>
/* eslint no-console: "off" */
import { mapState, mapMutations, mapActions } from 'vuex';
import webSocket from '@/common/webSocket';
import NewGameMixin from '@/common/mixins/home';
import { ParseResponseMixin, GameMixin2 } from '@/common/mixins/game';
import AttentionOdd from '@/components/home/game/attention/AttentionOdd';
import AttentionHoneyComb from '@/components/home/game/attention/AttentionHoneyComb';
import AttentionSquares from '@/components/home/game/attention/AttentionSquares';
import AttentionColor from '@/components/home/game/attention/AttentionColor';
import AttentionKnots from '@/components/home/game/attention/AttentionKnots';
import AttentionEmoji from '@/components/home/game/attention/AttentionEmoji';
import AttentionRollingList from '@/components/home/game/attention/AttentionRollingList';
import AttentionRollingListQuiz from '@/components/home/game/attention/AttentionRollingListQuiz';
import LogicMaths from '@/components/home/game/logic/LogicMaths';
import LogicMissingOperator from '@/components/home/game/logic/LogicMissingOperator';
import LogicPairs from '@/components/home/game/logic/LogicPairs';
import LogicEquation from '@/components/home/game/logic/LogicEquation';
import LogicSlices from '@/components/home/game/logic/LogicSlices';
import LogicGraterNum from '@/components/home/game/logic/LogicGraterNum';
import LogicMissingNum from '@/components/home/game/logic/LogicMissingNum';
import MemoryPattern from '@/components/home/game/memory/MemoryPattern';
import MemoryBombs from '@/components/home/game/memory/MemoryBombs';
import MemoryAttention from '@/components/home/game/memory/MemoryAttention';
import MemoryAttentionList from '@/components/home/game/memory/MemoryAttentionList';
import MemoryWizard from '@/components/home/game/memory/MemoryWizard';
import MemoryList from '@/components/home/game/memory/MemoryList';
import MemoryFourOfAKind from '@/components/home/game/memory/MemoryFourOfAKind';
import AttentionNumbers from '@/components/home/game/attention/AttentionNumbers';
import MemoryListQuiz from '@/components/home/game/memory/MemoryListQuiz';
import MemoryNames from '@/components/home/game/memory/MemoryNames';
import MemoryNamesQuiz from '@/components/home/game/memory/MemoryNamesQuiz';
import Timer from './Timer';
import GameFooter from './GameFooter';
import GameHeader from './GameHeader';
import PostGameBrainiac from '../modals/postgame/PostGameBrainiac';
import GameMaintenance from '../modals/Maintenance';
import NewGameModalWithGameMode from '../modals/postgame/NewGameModalWithGameMode';

export default {
  name: 'genericGameComponent',
  mixins: [NewGameMixin, ParseResponseMixin, GameMixin2],
  components: {
    NewGameModalWithGameMode,
    GameMaintenance,
    PostGameBrainiac,
    AttentionNumbers,
    GameHeader,
    GameFooter,
    Timer,
    AttentionOdd,
    AttentionHoneyComb,
    AttentionSquares,
    AttentionColor,
    AttentionKnots,
    AttentionEmoji,
    AttentionRollingList,
    AttentionRollingListQuiz,
    LogicMaths,
    LogicMissingNum,
    MemoryWizard,
    MemoryPattern,
    MemoryList,
    MemoryListQuiz,
    LogicMissingOperator,
    LogicEquation,
    LogicSlices,
    LogicGraterNum,
    LogicPairs,
    MemoryAttention,
    MemoryAttentionList,
    MemoryFourOfAKind,
    MemoryBombs,
    MemoryNames,
    MemoryNamesQuiz,
  },
  data() {
    return {
      componentModal: null,
      brainiacMiniGameMap: {
        ATT_COLORS: {
          miniGameComponent: AttentionColor,
        },
        ATT_ODD: {
          miniGameComponent: AttentionOdd,
        },
        ATT_HONEYCOMB: {
          miniGameComponent: AttentionHoneyComb,
        },
        ATT_NUMBERS: {
          miniGameComponent: AttentionNumbers,
        },
        ATT_SQUARES: {
          miniGameComponent: AttentionSquares,
        },
        ATT_KNOTS: {
          miniGameComponent: AttentionKnots,
        },
        ATT_EMOJI: {
          miniGameComponent: AttentionEmoji,
        },
        ATT_ROLLING_LIST: {
          miniGameComponent: AttentionRollingList,
        },
        ATT_ROLLING_LIST_QUIZ: {
          miniGameComponent: AttentionRollingListQuiz,
        },
        MEMORY_LIST: {
          miniGameComponent: MemoryList,
        },
        MEMORY_LIST_QUIZ: {
          miniGameComponent: MemoryListQuiz,
        },
        MEMORY_PATTERN: {
          miniGameComponent: MemoryPattern,
        },
        MEMORY_WIZARD: {
          miniGameComponent: MemoryWizard,
        },
        MEMORY_ATTENTION: {
          miniGameComponent: MemoryAttention,
        },
        MEM_FOUR_OF_A_KIND: {
          miniGameComponent: MemoryFourOfAKind,
        },
        MEMORY_BOMBS: {
          miniGameComponent: MemoryBombs,
        },
        MEMORY_ATTENTION_LIST: {
          miniGameComponent: MemoryAttentionList,
        },
        MEMORY_NAMES: {
          miniGameComponent: MemoryNames,
        },
        MEMORY_NAMES_QUIZ: {
          miniGameComponent: MemoryNamesQuiz,
        },
        LOGIC_MATHS: {
          miniGameComponent: LogicMaths,
        },
        LOGIC_MISSING_NUM: {
          miniGameComponent: LogicMissingNum,
        },
        LOGIC_MISSING_OPERATOR: {
          miniGameComponent: LogicMissingOperator,
        },
        LOGIC_EQUATION: {
          miniGameComponent: LogicEquation,
        },
        LOGIC_SLICES: {
          miniGameComponent: LogicSlices,
        },
        LOGIC_GRATER_NUM: {
          miniGameComponent: LogicGraterNum,
        },
        LOGIC_PAIRS: {
          miniGameComponent: LogicPairs,
        },
      },
      stompClient: null,
      subscription: null,
    };
  },
  created() {
    console.log('in Game created hook');
    this.stompClient = webSocket.getGameStompClient();
    this.initQuestionData();
    this.startSubscriptionChannel();
  },
  beforeDestroy() {
    console.log('in game\'s beforeDestroy hook');
    this.subscription.unsubscribe();
    this.resetGameState();
  },
  methods: {
    ...mapActions('profile', [
      'getUserLoginDetails',
    ]),
    ...mapMutations('game', [
      'resetGameState',
      'setGameInProgress',
    ]),
    stompFailure(error) {
      console.log(error);
      window.location.reload();
    },
    initQuestionData() {
      this.normalTransition = false;
    },
    startSubscriptionChannel() {
      console.info(`Subscribing to channel: /topic/finishedGame/${this.gameID}`);
      this.subscription = this.stompClient.subscribe(`/topic/finishedGame/${this.gameID}`, (response) => {
        // parse server response and return if any errors occur
        const responseData = this.parseServerResponse(response.body);
        if (responseData === null || responseData === 'Maintenance') {
          this.componentModal = GameMaintenance;
        } else {
          this.storeBrainiacPostGameData(this.parseServerResponse(response.body));
          this.componentModal = PostGameBrainiac;
        }
        this.normalTransition = true;
        this.showModal();
      });
    },
    startNewGameMethod() {
      this.setGameInProgress(false);
      this.componentModal = NewGameModalWithGameMode;
      this.showModal();
    },
    showModal() {
      /* eslint-disable */
      const vm = this;
      this.$nextTick(() => {
        // open modal
        $('.modal,.modal-overlay,.overlay').fadeIn(200);
        $("body").addClass("modal-open");
        // show/hide modal
        $('.modal-close, .modal-overlay,.btn_close, .overlay, .x_close').click(function () {
          $(".popup_box").fadeOut(200);
          $(".overlay").fadeOut(200);
          $('.modal, .modal-overlay').fadeOut();
          $("body").removeClass("modal-open");
          vm.getUserLoginDetails().then(() => {
            vm.$router.push('home');
          });
        });
      });
      /* eslint-enable */
    },
  },
  computed: {
    ...mapState('game', [
      'gameID',
      'miniGameType',
      'gameType',
      'gameMode',
      'miniGames',
      'currentMiniGameRound',
    ]),
    ...mapState('common', [
      'modalForHomePage',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/game/Game.vue